<template>
  <div class="member-wrapper">
    <div class='content'>
      <div class='img-div'>
        <common-upload-file :fileType='1' method="UpdateUserCertificatePath" @fileUpload="uploadFile($event)" :picUrl="params.CertificatePath">
        </common-upload-file>
      </div>
      <div class='tip-box'>
        <span>温馨提示</span>
        <p>根据相关部门规定，为了给您提供更好的互联网化服务，请您按照提示上传您本人的中华人民共和国医师资格证</p>
      </div>
      <div class='btn-wrap'>
        <div class="guide-cert-tip" @click="jumpGuideCert">
          <van-icon name="question" />如何填写,点这里>>
        </div>
        <div class='common-btn-wrap'>
          <van-button type="default" round size="large" @click='handleClick'>删除</van-button>
          <van-button type="info" round size="large" @click='handleSave'>保存</van-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommonUploadFile from '@/components/common/upload';
import { Toast, Dialog } from "vant";
export default {
  data () {
    return {
      params: {
        AppID: this.GLOBAL.AppID,
        Method: "UpdateUserCertificatePath",
        CertificatePath: '',
      },
      RegisterParams: {
        AppID: this.GLOBAL.AppID,
        Method: 'GetUserRegister',
      },
    }
  },
  methods: {
    handleSave () {
      this.$Request(this.params).then(res => {
        Toast.success({
          duration: 1000,
          message: '保存成功'
        });
        setTimeout(() => {
          this.$router.push({ path: '/person-data', replace: true })
        }, 3000)
      })
    },
    handleClick () {
      if (this.params.CertificatePath) {
        Dialog.confirm({
          message: '确定删除该资格证书吗？'
        }).then(() => {
          this.params.CertificatePath = ''
          this.$Request(this.params).then(res => {
            Toast.success({
              duration: 1000,
              message: '删除成功'
            });
            setTimeout(() => {
              this.$router.push({ path: '/person-data', replace: true })
            }, 3000)
          })
        });
      } else {
        Toast('请上传资质证书！')
      }

    },
    uploadFile ($event) {
      this.params.CertificatePath = $event
    },
    //跳转证书指引页
    jumpGuideCert () {
      this.$router.push({ path: '/guide-cert' });
    }
  },
  created () {
    this.$Request(this.RegisterParams).then(res => {
      if (res) {
        var UserObj = res;
        this.params.CertificatePath = UserObj.CertificatePath
      }
    })
  },
  components: {
    CommonUploadFile
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 20px;
  .img-div {
    width: 400px;
    max-height: 600px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    /deep/.van-uploader {
      /deep/.van-uploader__upload {
        width: 300px;
        height: 300px;
      }
    }
  }
  .tip-box {
    span {
      font-size: 28px;
      line-height: 2;
    }
    p {
      font-size: 24px;
      line-height: 1.5;
      color: #8f8f8f;
    }
  }
  .btn-wrap {
    position: absolute;
    height: 300px;
    width: 100%;
    max-width: 750px;
    bottom: 200px;
    left: 0;
    background-color: #fff;
    margin: 0 auto;
    .guide-cert-tip {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      color: @blue;
      padding: 20px 30px;
      .van-icon::before {
        font-size: 34px;
        margin-right: 10px;
      }
    }
    .btn-box {
      display: flex;
      align-items: center;
      width: 90%;
      margin: 0 auto 20px auto;
    }
  }
}

.van-button--primary {
  color: #fff;
  background-color: #269cca;
  border: 0.02667rem solid #269cca;
}
</style>


// WEBPACK FOOTER //
// src/views/member/qualitification-certificate.vue